import { PlatformApiEnhancerFunction } from '../../../types/platformApi';
import { getViewState, setViewState } from '../../services/viewStateService';

export const viewStateEnhancer: PlatformApiEnhancerFunction = (
  _platformApiMethods,
  { documentServices, experimentsAPI },
) => {
  return {
    editor: {
      widgets: {
        getViewState: getViewState.bind({}, documentServices, experimentsAPI),
        setViewState: setViewState.bind({}, documentServices, experimentsAPI),
      },
    },
  };
};
